// import React from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

// // Import your pages
// import Authpages from "./components/Authpages";


// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>

//         {/* Default Page */}
//         <Route path="/" element={<Authpages />} />


//         {/* 404 Page Not Found */}
//         <Route path="*" element={<h1 style={{ textAlign: "center", marginTop: "50px" }}>404 Page Not Found</h1>} />

//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;



import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";


import Authpages from "./components/Authpages";
import { SidebarProvider } from "./context/SidebarContext.jsx";// ← Make sure this path is correct
import { LoaderProvider } from "./context/LoaderProvider.jsx";


// ============================================== Food and Beverages ================================

import FoodDashboard from "./Component/Modules/FoodandBeverages/FoodDashboard.jsx";
import Landingnavbar from "./Component/Layouts/Landingnavbar.jsx";
import LandingSideBar2 from "./Component/Layouts/LandingSideBar2.jsx";
import Foodandbevaragenavbar from "./Component/Layouts/Foodandbevaragenavbar.jsx";
import ProtectedRoute from "./Component/Modules/Landingmanagment/ProtectedRoute";
import Foodbeveragescompany from "./Component/Modules/FoodandBeverages/Foodbeveragescompany";
import Foodsettings from "./Component/Modules/FoodandBeverages/Foodsettings";
import FoodandbeveragesMenu from "./Component/Modules/FoodandBeverages/FoodandbeveragesMenu";
import Menudatas from "./Component/Modules/Menumanagment/Food/Menudatas";
import Foodordermanagment from "./Component/Modules/FoodandBeverages/Foodordermanagment";
import Foodchefmanagment from "./Component/Modules/FoodandBeverages/Foodchefmanagment";
import Foodwaitermanagment from "./Component/Modules/FoodandBeverages/Foodwaitermanagment";
import FoodAccuont from "./Component/Modules/FoodandBeverages/FoodAccuont";
import Foodandbeveragespromotions from "./Component/Modules/FoodandBeverages/Foodandbeveragespromotions";
import Foodtablemanagment from "./Component/Modules/FoodandBeverages/Foodtablemanagment";
import FoodandbeveragesInvetory from "./Component/Modules/FoodandBeverages/FoodandbeveragesInvetory";
import Foodandreporanalysis from "./Component/Modules/FoodandBeverages/Foodandreporanalysis";
import Landingpagesubscription from "./Component/Modules/Landingmanagment/Landingpagesubscription";
 import FoodSupportSystem from "./Component/Modules/FoodandBeverages/FoodSupportSystem.jsx";
 import TeamManagment from "./Component/Modules/TeamManagment/TeamManagment.jsx";
import Subscriptionpage from "./Component/Modules/Landingmanagment/Subscriptionpage";
import NotificationContext from "./context/NotificationContext.jsx";
import FoodandbeveragesSupportSystem from "./Component/Modules/FoodandBeverages/FoodandbeveragesSupportSystem.jsx";
import SubscriptionPackages from "./Component/Modules/Landingmanagment/SubscriptionPackages.jsx";
import Foodratings from "./Component/Modules/FoodandBeverages/Foodratings.jsx";
import Waitermenu from "./Component/Modules/TableManagment/Waitermenu";
import TableCart from "./Component/Modules/TableManagment/TableCart";
import Supscriptionrenewal from "./Component/Modules/Accountandhistory/Supscriptionrenewal";
import MenuAdvertisement from "./Component/Modules/Menumanagment/Food/MenuAdvertisement.js";


// ============================================== Caterings ===================================

import CateringDashboard from "./Component/Modules/Caterings/CateringDashBoard.jsx";
import Cateringlading from "./Component/Modules/Caterings/Cateringlading";
import Cateringsprofilepage from "./Component/Modules/Caterings/Cateringsprofilepage";
import Cateringssettingpage from "./Component/Modules/Caterings/Cateringssettingpage";
import Cateringsmenuaddingpage from "./Component/Modules/Caterings/Cateringsmenuaddingpage";
import Cateringsorderspage from "./Component/Modules/Caterings/Cateringsorderspage";
import CaterigsAccount from "./Component/Modules/Caterings/CaterigsAccount";
import Cateringspromotionspage from "./Component/Modules/Caterings/Cateringspromotionspage";
import Cateringsreportanalysis from "./Component/Modules/Caterings/Cateringsreportanalysis";
import Cateringpackageorders from "./Component/Modules/Caterings/Cateringpackageorders";
import Cateringsidebar from "./Component/Layouts/Cateringsidebar.jsx";
import Cateringsnavbars from "./Component/Layouts/Cateringsnavbars.jsx";





function Layout() {
  const location = useLocation();

  const showLayout1 = location.pathname === "/mainnavbar" || location.pathname === "/delivery" || location.pathname === "/chef" || location.pathname === "/waitermanagement" || location.pathname === "/mainsidebar" || location.pathname === "/Newmainlandingpage" || location.pathname === "/notificationcontext";
  const showLayout2 = location.pathname === "/foodsupportsystem" || location.pathname === "/fooddashboard" || location.pathname === "/foodbeveragescompany" || location.pathname === "/foodsettings" || location.pathname === "/foodandbeveragesMenu" || location.pathname === "/menuiteams" 
                      || location.pathname === "/foodordermanagment" || location.pathname === "/foodchefmanagment" || location.pathname === "/foodwaitermanagment" || location.pathname === "/foodAccuontdata" || location.pathname === "/foodandbeveragespromotions" || location.pathname === "/foodtablemanagment" 
                      || location.pathname === "/foodandbeveragesInvetory" || location.pathname === "/foodandreporanalysis" || location.pathname === "/foodcart" || location.pathname === "/subscriptionrenewal" || location.pathname === "/fooddashboard" || location.pathname === "/foodsupportsystem" 
                      || location.pathname === "/teammanagment" || location.pathname === "/subscriptionpackages" || location.pathname === "/foodandbeveragessupportsystem" || location.pathname === "/foodratings" || location.pathname === "/waitermenu" || location.pathname === "/tableCart";
  const showLayout3 = location.pathname === "/cateringdashboard" || location.pathname === "/cateringlading" || location.pathname === "/cateringsprofilepage" || location.pathname === "/cateringssettingpage" || location.pathname === "/cateringsmenuaddingpage" || location.pathname === "/cateringsorderspage" 
                      || location.pathname === "/caterigsaccount" || location.pathname === "/cateringspromotionspage" || location.pathname === "/cateringsreportanalysis" || location.pathname === "/cateringrenewal" || location.pathname === "/cateringpackageorders";



  return (
    <div style={{ display: "flex", flexDirection: "column" }}>

      {showLayout1 && <Landingnavbar />}
      {showLayout2 && <Foodandbevaragenavbar />}
       {showLayout3 && <Cateringsnavbars />}
      <div style={{ display: "flex", flexGrow: 1 }}>


        {showLayout1 && <LandingSideBar2 />}
        {showLayout2 && <LandingSideBar2 />}
        {showLayout3 && <LandingSideBar2 />}

        <div style={{ flexGrow: 1 }}>
          <Routes>
            <Route path="/" element={<Authpages />} />

            {/* ================================== FOOD AND BEVERAGES ========================== */}
            <Route path="/fooddashboard" element={<ProtectedRoute><FoodDashboard /></ProtectedRoute>} />
            <Route path="/foodbeveragescompany" element={<ProtectedRoute><Foodbeveragescompany /></ProtectedRoute>} />
            <Route path="/foodsettings" element={<ProtectedRoute>< Foodsettings /></ProtectedRoute >} />
            <Route path="/foodandbeveragesMenu" element={<ProtectedRoute>< FoodandbeveragesMenu /></ProtectedRoute >} />
            <Route path="/menuiteams" element={<ProtectedRoute><Menudatas /></ProtectedRoute>} />
            <Route path="/foodordermanagment" element={<ProtectedRoute>< Foodordermanagment /></ProtectedRoute >} />
            < Route path="/foodchefmanagment" element={<ProtectedRoute>< Foodchefmanagment /></ProtectedRoute >} />
            < Route path="/foodwaitermanagment" element={<ProtectedRoute>< Foodwaitermanagment /></ProtectedRoute >} />
            < Route path="/foodAccuontdata" element={<ProtectedRoute>< FoodAccuont /></ProtectedRoute >} />
            < Route path="/foodandbeveragespromotions" element={<ProtectedRoute>< Foodandbeveragespromotions /></ProtectedRoute >} />
            < Route path="/foodandbeveragesInvetory" element={<ProtectedRoute>< FoodandbeveragesInvetory /></ProtectedRoute >} />
            < Route path="/foodtablemanagment" element={<ProtectedRoute>< Foodtablemanagment /></ProtectedRoute >} />
            < Route path="/foodandreporanalysis" element={<ProtectedRoute>< Foodandreporanalysis /></ProtectedRoute >} />
            <Route path="/subscriptionpackages" element={<ProtectedRoute><SubscriptionPackages /></ProtectedRoute>} />
            < Route path="/landingpagesubscription" element={< Landingpagesubscription />} />
            <Route path="/foodsupportsystem" element={<ProtectedRoute><FoodSupportSystem/></ProtectedRoute>} />
            <Route path="/teammanagment" element={<ProtectedRoute> <TeamManagment /></ProtectedRoute>} />
             <Route path="/subscriptionpage" element={<Subscriptionpage />} />
             < Route path="/notificationcontext" element={< ProtectedRoute > <NotificationContext /></ProtectedRoute >} />
             <Route path="/foodandbeveragessupportsystem" element={<ProtectedRoute><FoodandbeveragesSupportSystem/></ProtectedRoute>} />
            <Route path="/foodratings" element={<ProtectedRoute><Foodratings /></ProtectedRoute>} />
             <Route path="/waitermenu" element={<ProtectedRoute> <Waitermenu /></ProtectedRoute>} />
             <Route path="/tableCart" element={<ProtectedRoute><TableCart /></ProtectedRoute>} />
              <Route path="/subscriptionrenewal" element={<Supscriptionrenewal />} />
             <Route path="/menuadvertisement" element={<ProtectedRoute> <MenuAdvertisement /></ProtectedRoute>} />



            {/*============================= CATERINGS ========================= */}
            <Route path="/cateringdashboard" element={<ProtectedRoute><CateringDashboard /></ProtectedRoute>} />
            < Route path="/cateringlading" element={<ProtectedRoute>< Cateringlading /></ProtectedRoute >} />
            < Route path="/cateringsprofilepage" element={<ProtectedRoute>< Cateringsprofilepage /></ProtectedRoute >} />
            < Route path="/cateringssettingpage" element={<ProtectedRoute>< Cateringssettingpage /></ProtectedRoute >} />
            < Route path="/cateringsmenuaddingpage" element={<ProtectedRoute>< Cateringsmenuaddingpage /></ProtectedRoute >} />
            < Route path="/cateringsorderspage" element={<ProtectedRoute>< Cateringsorderspage /></ProtectedRoute >} />
            < Route path="/caterigsaccount" element={<ProtectedRoute>< CaterigsAccount /></ProtectedRoute >} />
            < Route path="/cateringspromotionspage" element={<ProtectedRoute>< Cateringspromotionspage /></ProtectedRoute >} />
             < Route path="/cateringsreportanalysis" element={<ProtectedRoute>< Cateringsreportanalysis /></ProtectedRoute >} />
             <Route path="/cateringpackageorders" element={<ProtectedRoute> <Cateringpackageorders /></ProtectedRoute>} />



          </Routes >
        </div >
      </div >
    </div >
  );
}




function App() {
  return (
    <LoaderProvider>
      <SidebarProvider>
      <Router>
        <Layout />
      </Router>
      </SidebarProvider>
    </LoaderProvider>
  );
}



export default App;
















// import React from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   useLocation,
// } from "react-router-dom";
// import Login from "./Component/Modules/Landingmanagment/Login";
// import Reports from "./Component/Modules/ReportandAnaysisManagment/Food/Reports";
// import Menu from "./Component/Modules/Menumanagment/Food/Menu";
// import Mainnavbar from './Component/Modules/Landingmanagment/Mainnavbar';
// import Mainsidebar from './Component/Modules/Landingmanagment/Mainsidebar';
// import Cartsdata from "./Component/Modules/Ordermanagment/Food/Cartsdata";
// import Subscriptiomhome from "./Component/Modules/Landingmanagment/Subscriptiomhome";
// import Newmainlandingpage from './Component/Modules/Caterings/Catreingfolder/Newmainlandingpage';
// import Settings from "./Component/Modules/Accountandhistory/Food/Settings";
// import ProtectedRoute from "./Component/Modules/Landingmanagment/ProtectedRoute";
// import Mainladdingpage from './Component/Modules/Landingmanagment/Mainladdingpage';
// import Company from "./Component/Modules/Landingmanagment/Company";
// import Payment from "./Component/Modules/Accountandhistory/Food/Payment";
// import Waitermanagement from "./Component/Modules/TableManagment/Waitermanagement";
// import Waitermenu from "./Component/Modules/TableManagment/Waitermenu";
// import Promotions from "./Component/Modules/PromotionsandDiscounts/Food/Foodpromotions";
// import TableCart from "./Component/Modules/TableManagment/TableCart";
// import Tablemanagement from "./Component/Modules/TableManagment/Tablemanagement";
// import Inventory from "./Component/Modules/Inventorymanagment/Food/Inventory";
// import CatgeringAll from "./Component/Modules/Caterings/CatgeringAll";
// import Cateringsetingcantrol from './Component/Modules/Caterings/Catreingfolder/Cateringsetingcantrol';
// import AddCategering from './Component/Modules/Caterings/Catreingfolder/AddCategering';
// import CateringOrders from './Component/Modules/Caterings/Catreingfolder/CateringOrders';
// import Catreingacounthistory from './Component/Modules/Caterings/Catreingfolder/Catreingacounthistory';
// import Careringaddhome from './Component/Modules/Caterings/Careringaddhome';
// import Catreingpromotion from './Component/Modules/Caterings/Catreingpromotion';
// import Home from "./Component/Modules/Landingmanagment/Home";
// import Catreingreports from './Component/Modules/Caterings/Catreingreports';
// import Chefmanagement from "./Component/Modules/Chefmanagment/Chefmanagement";
// import Delivery from "./Component/Modules/Ordermanagment/Food/Delivery";
// import Supscriptionrenewal from "./Component/Modules/Accountandhistory/Supscriptionrenewal";
// import Terms from "./Component/Modules/Accountandhistory/Terms";
// import Termsandcondions from "./Component/Modules/Accountandhistory/Termsandcondions";
// import FoodAccount from "./Component/Modules/Accountandhistory/Food/FoodAccount";
// import ItemUpdates from "./Component/Modules/Menumanagment/Food/ItemUpdates.jsx";
// import FoodSupportSystem from "./Component/Modules/FoodandBeverages/FoodSupportSystem.jsx";


// import FoodComponay from './Component/Modules/Profile/Food//FoodComponay';
// import Homemanagement from './Component/Modules/HomeManagment/Food/Homemanagement';
// import Cateringprofile from "./Component/Modules/Profile/Catering/Cateringprofile"
// import Groceryprofile from "./Component/Modules/Profile/Grocery/Groceryprofile";
// import FoodHomemanagment from "./Component/Modules/HomeManagment/Food/FoodHomemanagment";
// import CateringHome from "./Component/Modules/HomeManagment/Catering/CateringHome";
// import GroceryHome from "./Component/Modules/HomeManagment/Grocery/GroceryHome";
// import Foosettings from "./Component/Modules/Settingsandcontrolmanagment/Food/Foosettings";
// import Cateringsettings from "./Component/Modules/Settingsandcontrolmanagment/Caterings/Cateringsettings";
// import Grocerysettings from "./Component/Modules/Settingsandcontrolmanagment/Grocery/Grocerysettings";
// // import FoodMenu from "./Component/Modules/Menumanagment/Food/FoodMenu";
// import Menudatas from "./Component/Modules/Menumanagment/Food/Menudatas";
// // import CateringsMenu from "./Component/Modules/Menumanagment/Caterings/CateringsMenu";
// // import GroceryMenu from "./Component/Modules/Menumanagment/Grocery/GroceryMenu";
// // import Grocerymenudatas from "./Component/Modules/Menumanagment/Grocery/Grocerymenudatas";
// import Fooddata from "./Component/Modules/Ordermanagment/Food/Fooddata";
// import Cateringordersdata from "./Component/Modules/Ordermanagment/Caterings/Cateringordersdata";
// import Groceraccounts from "./Component/Modules/Accountandhistory/Grocery/Groceraccounts";
// import CateringAccounts from "./Component/Modules/Accountandhistory/Catering/CateringAccounts";
// import Foodpromotions from "./Component/Modules/PromotionsandDiscounts/Food/Foodpromotions";
// import Cateringpromotions from "./Component/Modules/PromotionsandDiscounts/Caterings/Cateringpromotions";
// import Grocerypromotions from "./Component/Modules/PromotionsandDiscounts/Grocery/Grocerypromotions";
// import Foodinventory from "./Component/Modules/Inventorymanagment/Food/Foodinventory";
// import CateringInventory from "./Component/Modules/Inventorymanagment/Caterings/CateringInventory";
// import GroceryInventory from "./Component/Modules/Inventorymanagment/Grocery/GroceryInventory";
// import Foodreports from "./Component/Modules/ReportandAnaysisManagment/Food/Foodreports";
// import Cateringreport from "./Component/Modules/ReportandAnaysisManagment/Caterings/Cateringreport";
// import Groceryreports from "./Component/Modules/ReportandAnaysisManagment/Grocery/Groceryreports";
// import Foodcart from "./Component/Modules/Menumanagment/Food/Foodcart";


// import Foodandbeveragesidebr from "./Component/Modules/FoodandBeverages/Foodandbeveragesidebr";
// import Foodbeveragescompany from "./Component/Modules/FoodandBeverages/Foodbeveragescompany";
// import Foodladingpage from "./Component/Modules/FoodandBeverages/Foodladingpage";
// import Foodsettings from "./Component/Modules/FoodandBeverages/Foodsettings";
// import FoodandbeveragesMenu from "./Component/Modules/FoodandBeverages/FoodandbeveragesMenu";
// import Foodordermanagment from "./Component/Modules/FoodandBeverages/Foodordermanagment";
// import Foodchefmanagment from "./Component/Modules/FoodandBeverages/Foodchefmanagment";
// import Foodwaitermanagment from "./Component/Modules/FoodandBeverages/Foodwaitermanagment";
// import FoodAccuont from "./Component/Modules/FoodandBeverages/FoodAccuont";
// import Foodandbeveragespromotions from "./Component/Modules/FoodandBeverages/Foodandbeveragespromotions";
// import Foodtablemanagment from "./Component/Modules/FoodandBeverages/Foodtablemanagment";
// import FoodandbeveragesInvetory from "./Component/Modules/FoodandBeverages/FoodandbeveragesInvetory";
// import Foodandreporanalysis from "./Component/Modules/FoodandBeverages/Foodandreporanalysis";
// import FoodDashboard from "./Component/Modules/FoodandBeverages/FoodDashboard.jsx";



// import Cateringlading from "./Component/Modules/Caterings/Cateringlading";
// import Cateringsprofilepage from "./Component/Modules/Caterings/Cateringsprofilepage";
// import Cateringssettingpage from "./Component/Modules/Caterings/Cateringssettingpage";
// import Cateringsmenuaddingpage from "./Component/Modules/Caterings/Cateringsmenuaddingpage";
// import Cateringsorderspage from "./Component/Modules/Caterings/Cateringsorderspage";
// import CaterigsAccount from "./Component/Modules/Caterings/CaterigsAccount";
// import Cateringspromotionspage from "./Component/Modules/Caterings/Cateringspromotionspage";
// import Cateringsreportanalysis from "./Component/Modules/Caterings/Cateringsreportanalysis";
// import Logisticssidebar from "./Component/Modules/Logisticsandservices/Logisticssidebar";
// import Logisticsprofilepage from "./Component/Modules/Logisticsandservices/Logisticsprofilepage";
// import Logisticsladingpage from "./Component/Modules/Logisticsandservices/Logisticsladingpage";
// import Logisticssettings from "./Component/Modules/Logisticsandservices/Logisticssettings";
// import Logisticsaccounts from "./Component/Modules/Logisticsandservices/Logisticsaccounts";
// // import Logisticsaccountsdata from "./Component/Modules/Logisticsandservices/Logisticsaccountsdata";
// import Logisticspromotionspage from "./Component/Modules/Logisticsandservices/Logisticspromotionspage";
// import Logisticsreport from "./Component/Modules/Logisticsandservices/Logisticsreport";
// import Landingpagesubscription from "./Component/Modules/Landingmanagment/Landingpagesubscription";
// import Cateringrenewal from "./Component/Modules/Caterings/Cateringrenewal";
// import NotificationContext from "./context/NotificationContext.jsx";
// import Groceryorders from "./Component/Modules/Grocery/Groceryorders.jsx"
// import Groceryladingpage from "./Component/Modules/Grocery/Groceryladingpage";
// import Groceryprofiledata from "./Component/Modules/Grocery/Groceryprofiledata";
// import Grocerysettingsdata from "./Component/Modules/Grocery/Grocerysettingsdata";
// import GroceryandbeveragesMenu from "./Component/Modules/Grocery/GroceryandbeveragesMenu";
// import Groceryordermanagment from "./Component/Modules/Grocery/Groceryordermanagment";
// import Grocerychefmanagment from "./Component/Modules/Grocery/Grocerychefmanagment";
// import Grocerywaitermanagment from "./Component/Modules/Grocery/Grocerywaitermanagment";
// import Groceryaccuontdata from "./Component/Modules/Grocery/Groceryaccuontdata";
// import Groceryandbeveragespromotions from "./Component/Modules/Grocery/Groceryandbeveragespromotions";
// import GroceryandbeveragesInvetory from "./Component/Modules/Grocery/GroceryandbeveragesInvetory";
// import Groceryandreporanalysis from "./Component/Modules/Grocery/Groceryandreporanalysis";

// import Grocerycart from "./Component/Modules/Grocery/cartpages/Grocerycart";
// import { LoaderProvider } from "./context/LoaderProvider.jsx";
// import Cateringpackageorders from "./Component/Modules/Caterings/Cateringpackageorders";
// import Subscriptionpage from "./Component/Modules/Landingmanagment/Subscriptionpage";
// import Onlineplaceorder from "./Component/Modules/Menumanagment/Food/Onlineplaceorder.jsx";



// // ================================= Nav Bars ============================================> //

// import Landingnavbar from "./Component/Layouts/Landingnavbar.jsx";
// import Landingsidebar from "./Component/Layouts/Landingsidebar.jsx";
// import LandingSideBar2 from "./Component/Layouts/LandingSideBar2.jsx";
// import Foodandbevaragenavbar from "./Component/Layouts/Foodandbevaragenavbar.jsx";
// import Foodandeveargessidebar from "./Component/Layouts/Foodandeveargessidebar.jsx";
// import Cateringsidebar from "./Component/Layouts/Cateringsidebar.jsx";
// import Cateringsnavbars from "./Component/Layouts/Cateringsnavbars.jsx";
// import Grocerysnavbar from "./Component/Layouts/Grocerysnavbar.jsx";
// import Groceryssidebar from "./Component/Layouts/Groceryssidebar.jsx";
// import Tablesnavbar from "./Component/Layouts/Tablesnavbar.jsx";

// function Layout() {
//   const location = useLocation();

//   const showLayout1 = location.pathname === "/mainnavbar" || location.pathname === "/delivery" || location.pathname === "/chef" || location.pathname === "/waitermanagement" || location.pathname === "/mainsidebar" || location.pathname === "/Newmainlandingpage" || location.pathname === "/notificationcontext";

//   const showLayout2 = location.pathname === "/foodbeveragescompany" || location.pathname === "/table" || location.pathname === "/foodaccount" || location.pathname === "/menuiteams" || location.pathname === "/foodladingpage" || location.pathname === "/foodsettings" || location.pathname === "/foodandbeveragesMenu" || location.pathname === "/foodordermanagment" || location.pathname === "/foodchefmanagment" || location.pathname === "/foodwaitermanagment" || location.pathname === "/foodmenu" || location.pathname === "/foodAccuontdata" || location.pathname === "/foodandbeveragespromotions" || location.pathname === "/foodtablemanagment" || location.pathname === "/foodandbeveragesInvetory" || location.pathname === "/foodandreporanalysis" || location.pathname === "/foodcart" || location.pathname === "/subscriptionrenewal" || location.pathname==="/fooddashboard" || location.pathname==="/foodsupportsystem";
//   const showLayout3 = location.pathname === "/cateringlading" || location.pathname === "/cateringsprofilepage" || location.pathname === "/cateringssettingpage" || location.pathname === "/cateringsmenuaddingpage" || location.pathname === "/cateringsorderspage" || location.pathname === "/caterigsaccount" || location.pathname === "/cateringspromotionspage" || location.pathname === "/cateringsreportanalysis" || location.pathname === "/cateringrenewal" || location.pathname === "/cateringpackageorders";
//   const showLayout4 = location.pathname === "/logisticsprofilepage" || location.pathname === "/logisticsladingpage" || location.pathname === "/logisticssettings" || location.pathname === "/logisticsaccounts" || location.pathname === "/logisticspromotionspage" || location.pathname === "/logisticsreport";
//   const showLayout5 = location.pathname === "/waitermenu" || location.pathname === "/tableCart";

//   const showLayout6 = location.pathname === "/groceryladingpage" || location.pathname === "/groceryprofiledata" || location.pathname === "/grocerysettingsdata" || location.pathname === "/groceryandbeveragesMenu" || location.pathname === "/groceryordermanagment" || location.pathname === "/grocerychefmanagment" || location.pathname === "/grocerywaitermanagment" || location.pathname === "/groceryaccuontdata" || location.pathname === "/groceryandbeveragespromotions" || location.pathname === "/groceryandbeveragesInvetory" || location.pathname === "/groceryandreporanalysis" || location.pathname === "/grocerymenudatas" || location.pathname === "/grocerycart" || location.pathname === "/groceryorders";




//   return (
//     <div style={{ display: "flex", flexDirection: "column" }}>

//       {showLayout1 && <Landingnavbar />}
//       {showLayout2 && <Foodandbevaragenavbar />}
//       {showLayout3 && <Cateringsnavbars />}
//       {showLayout4 && <Foodandbevaragenavbar />}
//       {showLayout5 && <Tablesnavbar />}
//       {showLayout6 && <Grocerysnavbar />}
//       <div style={{ display: "flex", flexGrow: 1 }}>

//         {/* {showLayout1 && <Landingsidebar />}
//         {showLayout2 && <Foodandeveargessidebar />}
//         {showLayout3 && <Cateringsidebar />}
//         {showLayout4 && <Foodandeveargessidebar />}
//         {showLayout5 && <Foodandbeveragesidebr />}
//         {showLayout6 && <Groceryssidebar />} */}
//         {showLayout1 && <LandingSideBar2 />}
//         {showLayout2 && <LandingSideBar2 />}
//         {showLayout3 && <LandingSideBar2 />}
//         {showLayout4 && <LandingSideBar2 />}
//         {showLayout5 && <LandingSideBar2 />}
//         {showLayout6 && <LandingSideBar2 />}
        
//         {/* { } */}
//         {/* {showLayout2 && <Patnersidebar />} */}
//         <div style={{ flexGrow: 1 }}>
//           <Routes>
//             <Route path="/" element={<Login />} />
//             <Route path="/Newmainlandingpage" element={<ProtectedRoute><Newmainlandingpage /></ProtectedRoute>} />
//             <Route path="/mainnavbar" element={<Mainnavbar />} />
//             <Route path="/mainsidebar" element={<Mainsidebar />} />
//             <Route path="/mainladdingpage" element={<Mainladdingpage />} />
//             <Route path="/company" element={<ProtectedRoute><Company /></ProtectedRoute>} />
//             <Route path="/foodhome" element={<ProtectedRoute><Subscriptiomhome /></ProtectedRoute>} />
//             {/* <Route path="/foodhome" element={<ProtectedRoute><Subscriptiomhome /></ProtectedRoute>} /> */}
//             <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
//             <Route path="/menu" element={<ProtectedRoute><Menu /></ProtectedRoute>} />
//             {/* <Route path="/menudatas" element={<Menudatas />} /> */}
//             <Route path="/cartsdata" element={<ProtectedRoute><Cartsdata /></ProtectedRoute>} />
//             <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
//             <Route path="/waitermanagement" element={<ProtectedRoute><Waitermanagement /></ProtectedRoute>} />
//             <Route path="/waitermenu" element={<Waitermenu />} />
//             <Route path="/tableCart" element={<ProtectedRoute><TableCart /></ProtectedRoute>} />
//             <Route path="/Promotions" element={<ProtectedRoute><Promotions /></ProtectedRoute>} />
//             <Route path="/table" element={<ProtectedRoute><Tablemanagement /></ProtectedRoute>} />
//             <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
//             <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
//             <Route path="/CatgeringAll" element={<CatgeringAll />} />
//             <Route path="/Cateringsetingcantrol" element={<ProtectedRoute><Cateringsetingcantrol /></ProtectedRoute>} />
//             <Route path="/AddCategering" element={<AddCategering />} />
//             <Route path="/CateringOrders" element={<ProtectedRoute><CateringOrders /></ProtectedRoute>} />
//             <Route path="/Catreingacounthistory" element={<ProtectedRoute><Catreingacounthistory /></ProtectedRoute>} />
//             <Route path="/Catreingpromotion" element={<ProtectedRoute><Catreingpromotion /></ProtectedRoute>} />
//             <Route path="/Catreingreports" element={<ProtectedRoute><Catreingreports /></ProtectedRoute>} />
//             <Route path="/Careringaddhome" element={<ProtectedRoute><Careringaddhome /></ProtectedRoute>} />
//             <Route path="/order" element={<ProtectedRoute><Home /></ProtectedRoute>} />
//             <Route path="/chef" element={<ProtectedRoute><Chefmanagement /></ProtectedRoute>} />
//             <Route path="/delivery" element={<ProtectedRoute><Delivery /></ProtectedRoute>} />
//             <Route path="/subscriptionrenewal" element={<Supscriptionrenewal />} />
//             <Route path="/terms" element={<Terms />} />

//             <Route path="/Termsandcondions" element={<ProtectedRoute><Termsandcondions /></ProtectedRoute>} />
//             <Route path="/onlineplaceorder" element={<ProtectedRoute><Onlineplaceorder /></ProtectedRoute>} />


//             <Route path="/foodaccount" element={<FoodAccount />} />
//             <Route path="/foodsupportsystem" element={<ProtectedRoute><FoodSupportSystem/></ProtectedRoute>} />

//             <Route path="/foodcomponay" element={<ProtectedRoute><FoodComponay /></ProtectedRoute>} />
//             <Route path="/homemanagements" element={<ProtectedRoute><Homemanagement /></ProtectedRoute>} />
//             <Route path="/cateringprofile" element={<ProtectedRoute><Cateringprofile /></ProtectedRoute>} />
//             <Route path="/groceryprofile" element={<ProtectedRoute><Groceryprofile /></ProtectedRoute>} />
//             <Route path="/foodhomemanagment" element={<ProtectedRoute><FoodHomemanagment /></ProtectedRoute>} />
//             <Route path="/cateringhome" element={<ProtectedRoute><CateringHome /></ProtectedRoute>} />
//             <Route path="/groceryhome" element={<ProtectedRoute><GroceryHome /></ProtectedRoute>} />
//             <Route path="/foosettings" element={<ProtectedRoute><Foosettings /></ProtectedRoute>} />
//             <Route path="/cateringsettings" element={<ProtectedRoute><Cateringsettings /></ProtectedRoute>} />
//             <Route path="/grocerysettings" element={<ProtectedRoute><Grocerysettings /></ProtectedRoute>} />
//             {/* <Route path="/foodmenu" element={<ProtectedRoute><FoodMenu /></ProtectedRoute>} /> */}

//             <Route path="/menuiteams" element={<ProtectedRoute><Menudatas /></ProtectedRoute>} />

//             {/* <Route path="/cateringsmenu" element={<ProtectedRoute><CateringsMenu /></ProtectedRoute>} /> */}
//             {/* <Route path="/grocerymenu" element={<ProtectedRoute><GroceryMenu /></ProtectedRoute>} /> */}
//             {/* <Route path="/grocerymenudatas" element={<ProtectedRoute><Grocerymenudatas /></ProtectedRoute>} /> */}

//             <Route path="/foodorders" element={<ProtectedRoute><Fooddata /></ProtectedRoute>} />
//             <Route path="/groceryorders" element={<ProtectedRoute><Groceryorders /></ProtectedRoute>} />
//             <Route path="/cateringordersdata" element={<ProtectedRoute><Cateringordersdata /></ProtectedRoute>} />
//             <Route path="/groceraccounts" element={<ProtectedRoute><Groceraccounts /></ProtectedRoute>} />
//             <Route path="/cateringaccounts" element={<ProtectedRoute><CateringAccounts /></ProtectedRoute>} />
//             <Route path="/foodpromotions" element={<ProtectedRoute><Foodpromotions /></ProtectedRoute>} />
//             <Route path="/cateringpromotions" element={<ProtectedRoute><Cateringpromotions /></ProtectedRoute>} />
//             <Route path="/grocerypromotions" element={<ProtectedRoute><Grocerypromotions /></ProtectedRoute>} />
//             <Route path="/foodinventory" element={<Foodinventory />} />
//             <Route path="/cateringinventory" element={<ProtectedRoute><CateringInventory /></ProtectedRoute>} />
//             <Route path="/groceryinventory" element={<ProtectedRoute><GroceryInventory /></ProtectedRoute>} />
//             <Route path="/foodreports" element={<ProtectedRoute><Foodreports /></ProtectedRoute>} />
//             <Route path="/cateringreport" element={<ProtectedRoute><Cateringreport /></ProtectedRoute>} />
//             <Route path="/groceryreports" element={<ProtectedRoute><Groceryreports /></ProtectedRoute>} />
//             <Route path="/foodcart" element={<ProtectedRoute><Foodcart /></ProtectedRoute>} />
//             <Route path="/foodbeveragescompany" element={<ProtectedRoute><Foodbeveragescompany /></ProtectedRoute>} />
//             < Route path="/foodladingpage" element={<ProtectedRoute>< Foodladingpage /></ProtectedRoute >} />
//             <Route path="/fooddashboard" element={<ProtectedRoute><FoodDashboard /></ProtectedRoute>} />
//             < Route path="/foodsettings" element={<ProtectedRoute>< Foodsettings /></ProtectedRoute >} />

//             < Route path="/foodordermanagment" element={<ProtectedRoute>< Foodordermanagment /></ProtectedRoute >} />
//             < Route path="/foodchefmanagment" element={<ProtectedRoute>< Foodchefmanagment /></ProtectedRoute >} />
//             < Route path="/foodwaitermanagment" element={<ProtectedRoute>< Foodwaitermanagment /></ProtectedRoute >} />
//             < Route path="/foodAccuontdata" element={<ProtectedRoute>< FoodAccuont /></ProtectedRoute >} />

//             < Route path="/foodandbeveragespromotions" element={<ProtectedRoute>< Foodandbeveragespromotions /></ProtectedRoute >} />
//             < Route path="/foodandbeveragesInvetory" element={<ProtectedRoute>< FoodandbeveragesInvetory /></ProtectedRoute >} />
//             < Route path="/foodandbeveragesMenu" element={<ProtectedRoute>< FoodandbeveragesMenu /></ProtectedRoute >} />


//             < Route path="/foodtablemanagment" element={<ProtectedRoute>< Foodtablemanagment /></ProtectedRoute >} />

//             < Route path="/foodandreporanalysis" element={<ProtectedRoute>< Foodandreporanalysis /></ProtectedRoute >} />
//             < Route path="/cateringlading" element={<ProtectedRoute>< Cateringlading /></ProtectedRoute >} />
//             < Route path="/cateringsprofilepage" element={<ProtectedRoute>< Cateringsprofilepage /></ProtectedRoute >} />
//             < Route path="/cateringssettingpage" element={<ProtectedRoute>< Cateringssettingpage /></ProtectedRoute >} />
//             < Route path="/cateringsmenuaddingpage" element={<ProtectedRoute>< Cateringsmenuaddingpage /></ProtectedRoute >} />
//             < Route path="/cateringsorderspage" element={<ProtectedRoute>< Cateringsorderspage /></ProtectedRoute >} />
//             < Route path="/caterigsaccount" element={<ProtectedRoute>< CaterigsAccount /></ProtectedRoute >} />
//             < Route path="/cateringspromotionspage" element={<ProtectedRoute>< Cateringspromotionspage /></ProtectedRoute >} />
//             < Route path="/cateringsreportanalysis" element={<ProtectedRoute>< Cateringsreportanalysis /></ProtectedRoute >} />
//             < Route path="/logisticsladingpage" element={<ProtectedRoute>< Logisticsladingpage /></ProtectedRoute >} />
//             < Route path="/logisticsprofilepage" element={<ProtectedRoute>< Logisticsprofilepage /></ProtectedRoute >} />
//             < Route path="/logisticssettings" element={<ProtectedRoute>< Logisticssettings /></ProtectedRoute >} />
//             < Route path="/logisticsaccounts" element={<ProtectedRoute>< Logisticsaccounts /></ProtectedRoute >} />
//             < Route path="/logisticspromotionspage" element={<ProtectedRoute>< Logisticspromotionspage /></ProtectedRoute >} />
//             < Route path="/logisticsreport" element={<ProtectedRoute>< Logisticsreport /></ProtectedRoute >} />

//             < Route path="/landingpagesubscription" element={< Landingpagesubscription />} />
//             < Route path="/cateringrenewal" element={< ProtectedRoute > <Cateringrenewal /></ProtectedRoute >} />
//             < Route path="/notificationcontext" element={< ProtectedRoute > <NotificationContext /></ProtectedRoute >} />
//             <Route path="/cateringpackageorders" element={<Cateringpackageorders />} />




//             {/* ========================================================= Grocery ====================================================================  */}
//             <Route path="/groceryladingpage" element={<Groceryladingpage />} />
//             <Route path="/groceryprofiledata" element={<Groceryprofiledata />} />
//             <Route path="/grocerysettingsdata" element={<Grocerysettingsdata />} />
//             <Route path="/groceryandbeveragesMenu" element={<GroceryandbeveragesMenu />} />
//             <Route path="/groceryordermanagement" element={<Groceryordermanagment />} />
//             <Route path="/grocerychefmanagment" element={<Grocerychefmanagment />} />
//             <Route path="/grocerywaitermanagment" element={<Grocerywaitermanagment />} />
//             <Route path="/groceryaccuontdata" element={<Groceryaccuontdata />} />
//             <Route path="/groceryandbeveragespromotions" element={<Groceryandbeveragespromotions />} />

//             <Route path="/groceryandbeveragesInvetory" element={<GroceryandbeveragesInvetory />} />
//             <Route path="/groceryandreporanalysis" element={<Groceryandreporanalysis />} />
//             <Route path="/grocerycart" element={<Grocerycart />} />
//             <Route path="/subscriptionpage" element={<Subscriptionpage />} />

//           </Routes >
//         </div >
//       </div >
//     </div >
//   );
// }


// // function App() {
// //   return (

// //     <Router>
// //       <Layout />
// //     </Router>
// //   );
// // }
// //  <Routes></Routes>
// // export default App;

// function App() {
//   return (
//     <LoaderProvider>
//       <Router>
//         <Layout />
//       </Router>
//     </LoaderProvider>
//   );
// }



// export default App;

